module.exports = __webpack_public_path__ + "img/share.821befcb.svg";